import { baseApi } from '../app/baseApi';
import type { Meeting } from '../../../shared/src/types/Meeting';
import type { FinancialData } from '../../../shared/src/types/FinancialData';

export interface Task {
  id: string;
  meeting_id: string;
  family_id: string;
  description: string;
  status: string;
  comments: string;
  original_meeting_id?: string | null;
  completed_at?: string | null;
  created_at: string;
  updated_at: string;
}

export interface PdfDataResponse {
  meeting: Meeting;
  tasks: Task[];
  financialData: FinancialData;
}

export const pdfApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPdfData: builder.query<PdfDataResponse, { meetingId: string; familyId: string }>({
      query: ({ meetingId, familyId }) => 
        `/pdf/pdf-data?meeting_id=${meetingId}&family_id=${familyId}`,
    }),
  }),
});


export const { useGetPdfDataQuery } = pdfApi;
